module.exports = __webpack_public_path__ + "static/media/uploadToCloud.bee895ae.svg";